import { useTableSetGlobalData } from '@tuqqi/web'
import React from 'react'

export const MockForSetTableGlobalData = () => {

    useTableSetGlobalData()
    return null
}